export default __webpack_public_path__ + "static/media/TwinMusicomNESTheme.5ec0ef6c.mp3";